import { numberApi } from '@reducers/number/number';

export function configureRoutingQueries({ did }) {
  const numberRoutingQuery = numberApi.useGetRoutingQuery({ did });
  const [deleteQuery, deleteResult] = numberApi.useDeleteRoutingMutation();
  const [addQuery, addResult] = numberApi.useAddRoutingMutation();
  const [updateQuery, updateResult] = numberApi.useUpdateRoutingMutation();

  return {
    add: { query: addQuery, result: addResult },
    get: { query: numberRoutingQuery },
    delete: { query: deleteQuery, result: deleteResult },
    update: { query: updateQuery, result: updateResult },
  };
}
export function configureShadowRoutingQueries({ did }) {
  const shadowRoutingQuery = numberApi.useGetShadowRoutingQuery({ did });
  const [updateQuery, updateResult] =
    numberApi.useUpdateShadowRoutingMutation();
  const [addQuery, addResult] = numberApi.useAddShadowRoutingMutation();
  const [deleteQuery, deleteResult] =
    numberApi.useDeleteShadowRoutingMutation();
  return {
    add: { query: addQuery, result: addResult },
    get: { query: shadowRoutingQuery },
    delete: { query: deleteQuery, result: deleteResult },
    update: { query: updateQuery, result: updateResult },
  };
}
